import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';

export const getRespondentData = createApiAction(types.GET_RESPONDENT_DATA);
export const getModuleGeneralInfo = createApiAction(
	types.GET_MODULE_GENERAL_INFO,
);
export const getModuleRatings = createApiAction(types.GET_MODULE_RATINGS);
export const getModuleEvaluation = createApiAction(types.GET_MODULE_EVALUATION);

export const getFinishModule = createApiAction(types.GET_FINISH_MODULE);

export const postSurveyData = createApiAction(types.POST_SURVEY_DATA);

export const setActiveModule = createAction(types.SET_ACTIVE_MODULE);
export const setProgress = createAction(types.SET_PROGRESS);
export const resetFinishModule = createAction(types.RESET_FINISH_MODULE);
export const finishSurvey = createAction(types.FINISH_SURVEY);
